import '../../../common-assets/styles/external/select2.min.css';
import '../../../common-assets/styles/pages/homepage.scss';
import '../styles/auto-homepage.scss';

import '../../../common-assets/js/components/ad_slider';
import '../../../common-assets/js/components/search_ad_history';
import '../../../common-assets/js/components/ad_recommendation';
import '../../../common-assets/js/components/ad_slider_datalayer';
import { SEARCH_AD_LISTING_PREFIX } from '../../../common-assets/js/components/common_utils';
import { searchPriceSlider } from '../../../common-assets/js/components/search/price_search_slider';
import { searchMileageSlider } from './components/mileage_search_slider';
import { simpleSearch } from './components/simple_search';
import { sliderOptionFormat } from '../../../common-assets/js/components/search/search_slider_format';
import { searchFormStorage } from '../../../common-assets/js/components/search/search_form_storage';

$(function () {
    let $body = $('body');

    // Reset form after back/forward navigation in browser history (mostly issue on chrome)
    window.addEventListener('pageshow', function (event) {
        // Check if the event persisted property is false (indicating a back/forward navigation) then reset the form
        if (!event.persisted) {
            document.getElementById('simple_search').reset();
            // Reset slider
            searchPriceSlider.setSlider(0, 0);
            searchMileageSlider.setSlider(0, 0);
            $('#priceRange,#mileageRange').html(`${Translations.no_lower_limit} - ${Translations.no_upper_limit}`);

            // reset popular make list & category list when back using browse history
            $('.makeList, .categoryList').prop('selectedIndex', 0);
        }
    });

    // Clear the search data from local storage
    searchFormStorage.saveFormData({});

    simpleSearch.init();
    searchPriceSlider.init();
    searchMileageSlider.init();

    $('#simple_search #priceFrom, #simple_search #priceTo').on('change', function () {
        sliderOptionFormat.validateRange($(this), searchPriceSlider);
    });

    $('#simple_search #kilometersFrom, #simple_search #kilometersTo').on('change', function () {
        sliderOptionFormat.validateRange($(this), searchMileageSlider);
    });

    $body.on('click', '.mostPopularHashGenerate', function () {
        const vehicleType = $(this).data('vehicle-type');

        $.ajax({
            url: Routing.generate('generate_search_hash'),
            type: 'POST',
            data: { vehicleType },
            timeout: 10000,
            success(response) {
                const listingUrl = Routing.generate('ad_listing', { arg1: SEARCH_AD_LISTING_PREFIX });
                const searchParam = response?.searchHash ? `?haku=${response.searchHash}` : '';
                globalThis.location.href = listingUrl + searchParam;
            },
            error() {
                const listingUrl = Routing.generate('ad_listing', { arg1: SEARCH_AD_LISTING_PREFIX });
                globalThis.location.href = listingUrl;
            },
        });
    });
});
